/**
 *
 * @param number - The number to get the prefix for
 * @returns The prefix for the number
 */

export const getNumberPrefix = (number: number, options: { withNumber?: boolean } = {}) => {
  const { withNumber = false } = options;

  const prefix = number > 0 ? "+" : "";
  return withNumber ? `${prefix}${number}` : prefix;
};
